var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0069 0.335938C3.31805 0.335938 0.333984 3.32 0.333984 7.00885C0.333984 10.6977 3.31805 13.6818 7.0069 13.6818C10.6957 13.6818 13.6798 10.6977 13.6798 7.00885C13.6798 3.32 10.6808 0.335938 7.0069 0.335938ZM7.0069 3.335C7.56173 3.335 8.01158 3.78486 8.01158 4.33969C8.01158 4.89451 7.56173 5.34437 7.0069 5.34437C6.45207 5.34437 6.00221 4.89451 6.00221 4.33969C6.00221 3.78486 6.45207 3.335 7.0069 3.335ZM8.34148 10.6677H7.99659H6.66201H6.33211C5.95723 10.6677 5.67232 10.3678 5.67232 10.0079C5.67232 9.63303 5.97222 9.34812 6.33211 9.34812H6.66201V7.33875H6.33211C5.95723 7.33875 5.67232 7.03884 5.67232 6.67896C5.67232 6.31907 5.97222 6.01916 6.33211 6.01916H7.3368C7.71168 6.01916 7.99659 6.31907 7.99659 6.67896V9.34812H8.32649C8.70137 9.34812 8.98628 9.64803 8.98628 10.0079C9.00128 10.3678 8.70137 10.6677 8.34148 10.6677Z",
    fill: "#141938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoBlue);
export default __webpack_public_path__ + "static/media/ic_info_blue.ce016c2f4efcdcdbffa67c7d17fdc095.svg";
export { ForwardRef as ReactComponent };